import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-20 px-4 bg-[#0d0d0d] border-t border-white/5 relative overflow-hidden" data-id="element-152">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-gamer-red/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-153"></div>

      <div className="max-w-3xl mx-auto" data-id="element-154">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="space-y-6" data-id="element-155">
          <div className="space-y-2 font-inter text-xl md:text-2xl text-gray-300 font-medium" data-id="element-156">
            <motion.p variants={itemVariants} data-id="element-157">Jugás todos los días.</motion.p>
            <motion.p variants={itemVariants} data-id="element-158">Entrenás.</motion.p>
            <motion.p variants={itemVariants} data-id="element-159">Mirá videos.</motion.p>
            <motion.p variants={itemVariants} data-id="element-160">Probás configuraciones.</motion.p>
            <motion.p variants={itemVariants} className="text-white font-bold pt-2" data-id="element-161">
              Y aún así… seguís perdiendo.
            </motion.p>
          </div>

          <motion.div variants={itemVariants} className="h-px w-24 bg-gamer-red my-8" data-id="element-162"></motion.div>

          <div className="space-y-4 font-inter text-lg text-gray-400" data-id="element-163">
            <motion.p variants={itemVariants} data-id="element-164">No es mala suerte.</motion.p>
            <motion.p variants={itemVariants} data-id="element-165">No es tu celular.</motion.p>
            <motion.p variants={itemVariants} className="text-white text-xl" data-id="element-166">
              Es que estás jugando sin{' '}
              <span className="text-gamer-red font-bold" data-id="element-167">estrategia real</span>.
            </motion.p>
          </div>

          <motion.div variants={itemVariants} className="mt-12 p-6 bg-gamer-red/5 border-l-4 border-gamer-red rounded-r-lg" data-id="element-168">
            <div className="flex items-start gap-4" data-id="element-169">
              <AlertTriangle className="w-8 h-8 text-gamer-red flex-shrink-0" data-id="element-170" />
              <p className="text-xl md:text-2xl font-orbitron font-bold text-white" data-id="element-171">
                En Free Fire, el que no tiene sistema…{' '}
                <span className="text-gamer-red underline decoration-wavy underline-offset-4" data-id="element-172">
                  pierde
                </span>
                .
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}